import React, {Component} from 'react';

class Posts extends Component {
    public render(){  
        return(
           <div>
            There is no need for this view for now.
           </div>
        );
    }
}


export default Posts